import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBuddyComponent } from './simple-icons-buddy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBuddyComponent ],
    exports:      [ SimpleIconsBuddyComponent ],
    bootstrap:    []
})
export class SimpleIconsBuddyModule {}
